import * as React from "react";
import type { SVGProps } from "react";
export const SvgLolRanksSilver = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="#80989D"
      fillRule="evenodd"
      d="M6.1 11.287c0-.578.129-1.148.379-1.67s.613-.982 1.065-1.348C5.62 7.597 2.82 6.259 2.007 4c0 0-.173 2.289 1.211 4.85 0 0 1.473.955 2.06 2.244l-1.143-.7c.29.92.644 1.816 1.06 2.685.665 1.268 1.904 2.227 1.904 2.227s-.576-1.713.1-1.302l.066.045a3.86 3.86 0 0 1-1.168-2.77l.002.008Zm6.42-3.035c.458.365.827.828 1.08 1.353a3.868 3.868 0 0 1 .244 2.724 3.877 3.877 0 0 1-.936 1.629c.5-.156 0 1.35 0 1.35s1.237-.963 1.903-2.227c.418-.868.772-1.765 1.061-2.683l-1.135.685C15.33 9.802 16.79 8.85 16.79 8.85 18.175 6.289 18.002 4 18.002 4c-.801 2.239-3.561 3.573-5.482 4.252Zm.213 3.035c0 1.471-1.204 2.664-2.69 2.664s-2.69-1.193-2.69-2.664 1.204-2.664 2.69-2.664 2.69 1.193 2.69 2.664Z"
      clipRule="evenodd"
    />
  </svg>
);
